module.exports = __webpack_public_path__ + "img/e89ff0e.png";